import { useState } from 'react';
var useGetStarted = function () {
    var _a = useState(null), video = _a[0], setVideo = _a[1];
    var _b = useState(false), checklistCompleted = _b[0], setChecklistCompleted = _b[1];
    var _c = useState(false), ready = _c[0], setReady = _c[1];
    var handleChecklistCompleted = function () {
        setChecklistCompleted(true);
    };
    return {
        handlePlayVideo: setVideo,
        video: video,
        checklistCompleted: checklistCompleted,
        handleChecklistCompleted: handleChecklistCompleted,
        ready: ready,
        setReady: function () { return setReady(true); },
    };
};
export { useGetStarted };
